import { rootStateBranchSelector } from '../../utils/rootStateBranchSelector';

export const getGAData = rootStateBranchSelector('gaData');
